import styled from 'styled-components';

import { Select } from '~/ui/components';
import { themeToggleValue } from '~/common/utils/theme';

type ActionsProps = {
  width?: string | number;
};

export const StyledSelect = styled(Select)<ActionsProps>`
  width: ${({ width = 'max-content' }) => (typeof width === 'number' ? `${width}px` : width)};

  //display: inline-block;
  //width: 200px;
  //white-space: nowrap;
  //overflow: hidden !important;
  //text-overflow: ellipsis;

  &.ant-cascader-picker {
    /* transparent in light keeps the original look; in dark match the standard
       field surface so it doesn't blend into the darker drawer behind it. */
    background-color: ${({ theme }) =>
      themeToggleValue(theme, 'transparent', { dark: theme.colors.background.primary })};
    border: 1.5px solid ${({ theme }) => theme.colors.divider.primary};
    border-radius: 8px;
  }

  &.ant-cascader-picker:hover {
    background-color: ${({ theme }) => theme.colors.neutral.secondary};
  }
`;
